import { useEffect, useCallback, useState } from "react";
import { tss } from "tss-react";
import { OutlinedInput, InputAdornment, Menu, MenuItem } from "@mui/material";
import { Scrollbars } from "react-custom-scrollbars";
import { Link } from "react-router-dom";
import { getCachedData } from "api/Cache";
import EventsEmitter from "events/EventsEmitter";
import { MAX_CATEGORY_HIT } from "constants/ui";
import { EntityInfo } from "components";
import { allArrayChildren } from "services/UtilsService";
import { Search } from "@mui/icons-material";
import commonStyles, { iconColor } from "styles/common";
import themeCfg from "config/theme.json";

const useStyles = tss.create({
    globalSearchRoot: {
        marginLeft: 7,
        position: "relative",
        height: "100%",
        width:'90%',
        marginRight : 10,
        background:'#FDFDFD'
    },
    search: {
        height: 40,
        width: '100%',
        borderRadius: 5,
        marginRight: 20,
        border:'0'
    },
    menuHeader: {
        fontWeight: "bold",
        marginTop: 10,
        color: themeCfg.sideTopColor,
        fontSize: '16px !important'
    },
    menuItem: {
        paddingLeft: 25,
        paddingRight : 25
    },
    link: {
        textDecoration: "none",
        //color: labelColor,
        position: "relative",
        color: themeCfg.sideTopColor
    },
    section: {
        position: "relative",
        minHeight: 40,
        display: "flex",
        alignItems: "flex-start",
        padding: '15px',
        flexDirection: 'column'
    },
    showMore: {
        height: 14,
        position: "absolute",
        right: 10,
        padding:15,
        alignSelf: 'flex-end',
        color:'#28ABE3 !important'
    },
    icon: {
        width: 16,
        height: 16,
        paddingTop: 2,
        paddingRight: 3,
        color: iconColor,
    },
});

var keyword = "";

const initShowMore = {
    projects: false,
    views: false,
    entities: false,
};

const initResult = {
    projects: [],
    views: [],
    entities: [],
};

type IProps = {
    label: string;
    type: string;
    results: any;
    showMore: any;
    showAll: (type: string) => void;
    showLess: (type: string) => void;
};

const SearchSection = (props: IProps) => {
    const { classes, cx } = useStyles();
    const { classes: common } = commonStyles();
    const { label, type, results, showMore, showAll, showLess } = props;
    var kind = type;
    if (type === "projects" || type === "entities") {
        kind = "catalog";
    }
    const eventBroadcast = (kind: string) => {
        EventsEmitter.emit("changeTab", kind);
    };
    return (
        <div>
            {results[type].length === 0 ? (
                ""
            ) : (
                <div className={classes.section}>
                    <MenuItem className={cx(classes.menuHeader, common.label)}>{label}</MenuItem>
                    {results[type].map((result: any, index: number) => {
                        if (showMore[type]) {
                            if (index < MAX_CATEGORY_HIT) {
                                return (
                                    <Link
                                        key={"result-" + type + "1-" + index}
                                        to={"/" + kind + "/" + result.ID}
                                        className={classes.link}
                                        onClick={(e: any) => eventBroadcast(kind)}
                                    >
                                        <EntityInfo entity={result} />
                                    </Link>
                                );
                            }
                        } else {
                            return (
                                <Link
                                    key={"result-" + type + "2-" + index}
                                    to={"/" + kind + "/" + result.ID}
                                    className={classes.link}
                                >
                                    <EntityInfo entity={result} />
                                </Link>
                            );
                        }
                        return "";
                    })}
                    {showMore[type] ? (
                        <MenuItem className={cx(classes.showMore, common.smallLabel)} onClick={() => showAll(type)}>
                            Show More
                        </MenuItem>
                    ) : results[type].length > MAX_CATEGORY_HIT ? (
                        <MenuItem className={cx(classes.showMore, common.smallLabel)} onClick={() => showLess(type)}>
                            Show Less
                        </MenuItem>
                    ) : (
                        ""
                    )}
                </div>
            )}
        </div>
    );
};

export default function GlobalSearch() {
    const { classes, cx } = useStyles();
    const { classes: common } = commonStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const [results, setResults] = useState(initResult);
    const [showMore, setShowMore] = useState(initShowMore);
    const data = getCachedData();
    const projects = Object.values(data["projects"]);
    var entities: any = Object.values(data["entities"]);

    const handleChange = useCallback(
        (evt: any, byPass?: boolean) => {
            if (evt.keyCode !== 13 && !byPass) {
                return;
            }
            if (!byPass) {
                keyword = evt.target.value.toLowerCase();
            }
            keyword = keyword.trim();
            console.log("keyword:", keyword);

            var newShowMore: any = { ...initShowMore };
            var newResults: any = { ...initResult };
            if (keyword.length === 0) {
                setResults({ ...newResults });
                setAnchorEl(evt.currentTarget);
                return;
            }
            try {
                const regex = new RegExp(keyword, "g");
                var allEntities: any = allArrayChildren(entities);
                newResults.views = allEntities.filter((entity: any) => {
                    return (
                        entity.state === "COMPLETE" &&
                        entity.virtual !== "1" &&
                        entity.view_type === "container" &&
                        entity.name &&
                        entity.name.toLowerCase().match(regex)
                    );
                });
                if (newResults.views.length > MAX_CATEGORY_HIT) {
                    newShowMore = { ...newShowMore, views: true };
                }
                newResults.projects = projects.filter((project: any) => {
                    return project.name && project.name.toLowerCase().match(regex);
                });
                if (newResults.projects.length > MAX_CATEGORY_HIT) {
                    newShowMore = { ...newShowMore, projects: true };
                }

                const filterFunc = (entity: any) => {
                    return (
                        entity.state === "COMPLETE" &&
                        entity.virtual !== "1" &&
                        entity.view_type !== "container" &&
                        entity.name &&
                        entity.name.toLowerCase().match(regex)
                    );
                };

                newResults.entities = allEntities.filter(filterFunc);
                if (newResults.entities.length > MAX_CATEGORY_HIT) {
                    newShowMore = { ...newShowMore, entities: true };
                }
                setShowMore(newShowMore);
                setResults(newResults);
                if (!byPass) {
                    setAnchorEl(evt.currentTarget);
                }
            } catch (e) {}
        },
        [projects, entities]
    );
    useEffect(() => {
        var updateData = () => {
            if (anchorEl !== null) {
                handleChange(keyword, true);
            }
        };
        EventsEmitter.on("dataReady", updateData);
        return () => {
            EventsEmitter.removeEventListener("dataReady", updateData);
        };
    }, [anchorEl, handleChange]);
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const showAll = (type: string) => {
        var newShowMore: any = { ...showMore };
        newShowMore[type] = false;
        setShowMore(newShowMore);
    };
    const showLess = (type: string) => {
        var newShowMore: any = { ...showMore };
        newShowMore[type] = true;
        setShowMore(newShowMore);
    };
    return (
        <div className={classes.globalSearchRoot}>
            <OutlinedInput
                className={classes.search}
                placeholder="Search..."
                startAdornment={
                    <InputAdornment position="start">
                        <Search />
                    </InputAdornment>
                }
                sx={{
                    "&.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#F7f7f7"
                    },
                    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#ccc"
                    },                    
                    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#ccc"
                    },
                }}
                onKeyDownCapture={handleChange}
            />
            <Menu
                id="menu-list-search-grow"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
            >
                <Scrollbars autoHeight autoHeightMax={500} style={{ overflowX: "hidden", minWidth: 600, minHeight: 50 }}>
                    {results.entities.length + results.projects.length + results.views.length === 0 ? (
                        <div className={common.middle} style={{ height: 50 }}>
                            <MenuItem className={cx(classes.menuItem, common.smallLabel)}>No Results</MenuItem>
                        </div>
                    ) : (
                        <div>
                            <SearchSection
                                label="Views"
                                type="views"
                                results={results}
                                showMore={showMore}
                                showAll={showAll}
                                showLess={showLess}
                            />
                            <SearchSection
                                label="Projects"
                                type="projects"
                                results={results}
                                showMore={showMore}
                                showAll={showAll}
                                showLess={showLess}
                            />
                            <SearchSection
                                label="Entities"
                                type="entities"
                                results={results}
                                showMore={showMore}
                                showAll={showAll}
                                showLess={showLess}
                            />
                        </div>
                    )}
                </Scrollbars>
            </Menu>
        </div>
    );
}
